/* LélekHorgony — feltételes ajándék e-book motor (v2, drawer-biztos).
   Mátrix (villák összesen >= 2 db): MINDEN villához a SAJÁT e-könyve jár.
     - 128  -> Testpont térkép
     - 528  -> 28 napos szándéknapló
     - 4096 -> Kristályok és csakrák
     (pl. 128+528 -> Testpont + Szándéknapló · 2 db 528 -> Szándéknapló · 1 villa -> semmi)
   Működés: a téma kosár-mutáló fetch-eit elkapjuk, a válasz visszaadása ELŐTT
   lefuttatjuk az ajándék-szinkront, majd a válasz `sections` mezőjét friss
   (ajándék utáni) HTML-re cseréljük -> a Shrine a SAJÁT renderContents útján
   rajzolja újra a drawert. Mi SOHA nem nyúlunk a DOM-hoz (a v1 innerHTML-cseréje
   törte a drawer állapotát: eltűnő panel + beragadt overlay).
   Az ajándékok DEDIKÁLT 0 Ft-os iker-termékek (testpont-terkep-ajandek,
   kristalyok-es-csakrak-tisztitasa-ajandek, 28-napos-szandeknaplo-ajandek)
   -> az ár natívan nulla kosárban és
   checkoutban, discount-motor nélkül. A fizetős e-bookok (4 990 Ft) érintetlenek.
   Solo-URL védelem: a mátrix minden kosár-változásnál érvényesül, a jogosulatlan
   0 Ft-os ikret a motor automatikusan eltávolítja.
   Vevő-törlés tiszteletben: ugyanannál a kosár-összetételnél nem adjuk vissza. */
(function () {
  if (window.__lhGiftInit) { return; }
  window.__lhGiftInit = true;

  var CFG = window.LH_GIFT_CONFIG;
  if (!CFG || !CFG.forks || !CFG.gifts) { return; }

  var origFetch = window.fetch.bind(window);
  var busy = false;
  var queued = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function giftVariants() {
    return [CFG.gifts.testpont.variant, CFG.gifts.szandeknaplo.variant, CFG.gifts.kristalyok.variant];
  }

  function desired(cart) {
    var q128 = 0, q528 = 0, q4096 = 0;
    cart.items.forEach(function (it) {
      if (it.product_id === CFG.forks.f128) { q128 += it.quantity; }
      else if (it.product_id === CFG.forks.f528) { q528 += it.quantity; }
      else if (it.product_id === CFG.forks.f4096) { q4096 += it.quantity; }
    });
    var want = [];
    if (q128 + q528 + q4096 >= 2) {
      if (q128 > 0) { want.push(CFG.gifts.testpont.variant); }
      if (q528 > 0) { want.push(CFG.gifts.szandeknaplo.variant); }
      if (q4096 > 0) { want.push(CFG.gifts.kristalyok.variant); }
    }
    return { want: want, compKey: q128 + '|' + q528 + '|' + q4096 };
  }

  function readList(key) {
    try { return (sessionStorage.getItem(key) || '').split(',').filter(Boolean); } catch (e) { return []; }
  }
  function writeList(key, arr) {
    try { sessionStorage.setItem(key, arr.join(',')); } catch (e) {}
  }

  function cartFetch(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-LH-Gift': '1' },
      body: JSON.stringify(body)
    });
  }

  /* A mátrix érvényesítése. Visszatérés: hány műveletet végzett (0 = nem nyúlt semmihez). */
  function syncInner() {
    return origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'X-LH-Gift': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d = desired(cart);

        try {
          if (sessionStorage.getItem('lhGiftComp') !== d.compKey) {
            sessionStorage.setItem('lhGiftComp', d.compKey);
            sessionStorage.removeItem('lhGiftOptout');
          }
        } catch (e) {}

        var optout = readList('lhGiftOptout');
        var given = readList('lhGiftGiven');

        var present = {};
        cart.items.forEach(function (it) {
          if (giftVariants().indexOf(it.variant_id) > -1) { present[it.variant_id] = it; }
        });

        d.want.forEach(function (v) {
          if (given.indexOf(String(v)) > -1 && !present[v] && optout.indexOf(String(v)) === -1) {
            optout.push(String(v));
          }
        });
        writeList('lhGiftOptout', optout);

        var ops = [];
        d.want.forEach(function (v) {
          if (!present[v] && optout.indexOf(String(v)) === -1) { ops.push({ t: 'add', v: v }); }
        });
        Object.keys(present).forEach(function (vs) {
          var v = parseInt(vs, 10);
          if (d.want.indexOf(v) === -1) { ops.push({ t: 'zero', k: present[vs].key }); }
          else if (present[vs].quantity !== 1) { ops.push({ t: 'one', k: present[vs].key }); }
        });

        var chain = Promise.resolve();
        ops.forEach(function (op) {
          chain = chain.then(function () {
            if (op.t === 'add') {
              return cartFetch(root + 'cart/add.js', { items: [{ id: op.v, quantity: 1, properties: { _lh_gift: '1', '\ud83c\udf81 Aj\u00e1nd\u00e9k': 'ingyen a szetthez' } }] });
            }
            return cartFetch(root + 'cart/change.js', { id: op.k, quantity: op.t === 'zero' ? 0 : 1 });
          });
        });

        return chain.then(function () {
          writeList('lhGiftGiven', d.want.filter(function (v) { return optout.indexOf(String(v)) === -1; }).map(String));
          return ops.length;
        });
      });
  }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(0); }
    busy = true;
    return syncInner()
      .catch(function () { return 0; })
      .then(function (n) {
        busy = false;
        if (queued) { queued = false; setTimeout(sync, 250); }
        return n;
      });
  }

  /* Friss sections-HTML lekérése az ajándék-műveletek UTÁN. */
  function fetchSections(ids) {
    return origFetch(root + '?sections=' + ids.join(','), {
      credentials: 'same-origin',
      headers: { 'X-LH-Gift': '1' }
    }).then(function (r) { return r.json(); });
  }

  function isOurs(init) {
    if (!init || !init.headers) { return false; }
    var h = init.headers;
    if (typeof h.get === 'function') { return h.get('X-LH-Gift') === '1'; }
    return h['X-LH-Gift'] === '1';
  }

  /* Fetch-elfogás: a téma kosár-mutációja után szinkron + sections-csere a válaszban. */
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var mutation = /\/cart\/(add|change|update|clear)/.test(url);
    if (!mutation || isOurs(init)) {
      return origFetch(input, init);
    }
    return origFetch(input, init).then(function (res) {
      if (!res.ok) { return res; }
      var clone = res.clone();
      return clone.json().then(function (data) {
        return sync().then(function (opsDone) {
          if (!opsDone || !data || !data.sections) { return res; }
          var ids = Object.keys(data.sections);
          return fetchSections(ids).then(function (fresh) {
            ids.forEach(function (id) { if (fresh[id]) { data.sections[id] = fresh[id]; } });
            return new Response(JSON.stringify(data), {
              status: res.status,
              statusText: res.statusText,
              headers: { 'Content-Type': 'application/json' }
            });
          }).catch(function () { return res; });
        }).catch(function () { return res; });
      }).catch(function () { return res; });
    });
  };

  /* Oldalbetöltéskor egy csendes szinkron (DOM-ot nem érintünk). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 400); });
  } else {
    setTimeout(sync, 400);
  }

  /* Lassú biztonsági háló nem-fetch alapú kosár-utakhoz — szintén DOM-mentes. */
  setInterval(function () {
    if (!document.hidden && !busy) { sync(); }
  }, 6000);
})();
